// @flow

//
// React
//
import React from 'react';

//
// Formatter
//
import { fmtMoney } from '../../../../trix-web-data-commons';

//
// Type
//
import {
    type CellRendererFactoryProps,
    type CellProps,
} from '../types/CellProps';

//
// Helper
//
import { renderAsLink } from './tools';

//
// Component
//
const createMoneyCellRenderer = (cfg: CellRendererFactoryProps): any => (props: CellProps): any => {
    return (
        <div>
            {renderAsLink(cfg.onClick, props.row)(fmtMoney(props.value))}
        </div>
    );
};
export default createMoneyCellRenderer;
